import React from 'react';
import contactImage from '../assets/MAIN/CONTACT.png';
import contactBack from '../assets/MAIN/Contact back.png';

const Footer = () => {
  return (
    <section className="contact-section footer" id="contact">
      <div className="contact-content">
        <div className="contact-left">
          <div className="contact-background">
            <img src={contactBack} alt="Contact Background" />
            <div className="contact-info">
              <div className="contact-text-1">Freelance projects and full-time opportunities. Let's get acquainted</div>
              <div className="contact-buttons">
                <button 
                  className="contact-btn"
                  onClick={() => window.location.href = 'mailto:anastasiia.dzev@gmail.com'}
                >
                  anastasiia.dzev@gmail.com
                </button>                       
                <button 
                  className="contact-btn" 
                  onClick={() => window.open('https://t.me/Adzhevelik', '_blank')}
                >
                  DM in Telegram
                </button>
              </div>
              <div className="contact-footer-text">Imprint, Privacy, Cookies</div>
            </div>
          </div>
        </div>
        <div className="contact-right">
          <img src={contactImage} alt="Contact" className="contact-image" />
        </div>
      </div>
    </section>
  );
};

export default Footer;